export default "__VITE_ASSET__U1pL9SBD__"